import { render, staticRenderFns } from "./SaffronJob.vue?vue&type=template&id=e919c5c0&scoped=true&"
import script from "./SaffronJob.vue?vue&type=script&lang=js&"
export * from "./SaffronJob.vue?vue&type=script&lang=js&"
import style0 from "./SaffronJob.vue?vue&type=style&index=0&id=e919c5c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e919c5c0",
  null
  
)

export default component.exports